// noinspection JSAnnotator
const state = {
  forms: [],
  form: [],
  formId: 0,
  formOpened: false,
};

// noinspection JSAnnotator
const mutations = {
  'SET_FORM_DETAIL'(state, detail) {
    if (detail) {
      state.form = detail;
      state.formId = detail.formId;
    }
  },
  'GET_FORM_DETAIL'() {
    return state.form;
  },
  'UPDATE_FORM_DETAIL'(state, detail) {
    state.form.unshift(detail);
  },

  'SET_FORM_OPENED'(state, detail) {
    state.formOpened = detail;
  },
  'GET_FORM_OPENED'() {
    return state.formOpened;
  },

  'SET_FORMS_DETAIL'(state, detail) {
    if (detail) {
      state.forms = detail;
    }
  },
  'GET_FORMS_DETAIL'() {
    return state.forms;
  },
  'UPDATE_FORMS_DETAIL'(state, detail) {
    state.forms.unshift(detail);
  }
};

const actions = {
  setForm: ({commit}, detail) => {
    commit('SET_FORM_DETAIL', detail);
  },
  updateForm: ({commit}, detail) => {
    commit('UPDATE_FORM_DETAIL', detail);
  },
  setFormList: ({commit}, detail) => {
    commit('SET_FORMS_DETAIL', detail);
  },
  updateFormList: ({commit}, detail) => {
    commit('UPDATE_FORMS_DETAIL', detail);
  },

  setFormOpened: ({commit}, detail) => {
    commit('SET_FORM_OPENED', detail);
  },
  getFormOpened: ({commit}, detail) => {
    commit('SET_FORM_OPENED', detail);
  },
};

const getters = {
  getFormList: () => {
    return state.forms;
  },
  getForm: (state) => {
    return state.form;
  },
  getFormId: (state) => {
    return state.formId;
  },
  getFormOpened: (state) => {
    return state.formOpened;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};




// WEBPACK FOOTER //
// ./src/store/modules/Form.store.js